import { gql } from '@apollo/client';

export const GET_USER = gql`
  query GetUser {
    user {
      id
      email
      userType
      isActive
      organizationId
      roleType
      firstName
      lastName
      organization {
        id
        industry
        name
        slug
        orgPreferences {
          cashBalancePreference
        }
      }
    }
  }
`;

export const GET_USER_ACTIVE_CREDIT_FACILITIES = gql`
  query GetUserActiveCreditFacilities($creditFacilitySlugsToHide: [String!]!) {
    user(creditFacilitySlugsToHide: $creditFacilitySlugsToHide) {
      id
      email
      userType
      isActive
      organizationId
      roleType
      firstName
      lastName
      organization {
        id
        industry
        name
        slug
        creditFacilities {
          id
          slug
          latestCreditAgreementId
        }
      }
    }
  }
`;

export const GET_CAPITAL_PROVIDERS_FOR_CREDIT_FACILITY = gql`
  query GetCapitalProviders($creditFacilityId: UUID!) {
    capitalProviders(creditFacilityId: $creditFacilityId) {
      id
      name
      type
      slug
      industry
    }
  }
`;
